import { ChatJob } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function submitChatJob(httpClient: HttpClient) {
  return (question: string, conversationId?: string) =>
    httpClient.sendHttpRequest<ChatJob>({
      endpoint: `/secured/jobs`,
      method: HttpMethods.POST,
      data: { question, ...(conversationId ? { conversationId } : {}) },
    });
}

export { submitChatJob };
